module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "admin-tab"
  }, [_c('wb-datatable', _vm._b({
    attrs: {
      "searchKey": 'name'
    },
    on: {
      "addEmit": _vm.openDialog,
      "editEmit": _vm.openDialog,
      "deleteEmit": _vm.openConfirmDialog
    }
  }, 'wb-datatable', _vm.tableProps, false)), _vm._v(" "), _c('md-dialog', {
    ref: "dialog"
  }, [_c('md-dialog-title', [_vm._v(_vm._s(_vm.isNew ? 'Create documentation' : 'Update documentation'))]), _vm._v(" "), _c('md-dialog-content', [(_vm.documentation) ? _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.closeDialog(true)
      }
    }
  }, [_c('md-input-container', [_c('label', [_vm._v("Name")]), _vm._v(" "), _c('md-input', {
    model: {
      value: (_vm.documentation.name),
      callback: function($$v) {
        _vm.$set(_vm.documentation, "name", $$v)
      },
      expression: "documentation.name"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Collection")]), _vm._v(" "), _c('md-input', {
    model: {
      value: (_vm.documentation.collection),
      callback: function($$v) {
        _vm.$set(_vm.documentation, "collection", $$v)
      },
      expression: "documentation.collection"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('multiselect', {
    attrs: {
      "id": "docKey",
      "options": _vm.keys,
      "multiple": false,
      "close-on-select": true,
      "placeholder": "Key",
      "label": "Key"
    },
    model: {
      value: (_vm.selectedKey),
      callback: function($$v) {
        _vm.selectedKey = $$v
      },
      expression: "selectedKey"
    }
  })], 1), _vm._v(" "), (_vm.isNew) ? _c('md-input-container', [_c('label', [_vm._v("Position")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.documentation.position),
      callback: function($$v) {
        _vm.$set(_vm.documentation, "position", $$v)
      },
      expression: "documentation.position"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', [_c('md-switch', {
    attrs: {
      "id": "docSecured"
    },
    model: {
      value: (_vm.documentation.secured),
      callback: function($$v) {
        _vm.$set(_vm.documentation, "secured", $$v)
      },
      expression: "documentation.secured"
    }
  }, [_vm._v("Secured")])], 1)], 1) : _vm._e()]), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        return _vm.closeDialog(false)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        return _vm.closeDialog(true)
      }
    }
  }, [_vm._v(_vm._s(_vm.isNew ? 'Create' : 'Update'))])], 1)], 1), _vm._v(" "), _c('md-dialog', {
    ref: "confirmDialog"
  }, [_c('md-dialog-title', [_vm._v("Are you sure you would like to remove this documentation?")]), _vm._v(" "), _c('md-dialog-content', [_vm._v("\n            Documentation will permanently be removed from the database\n        ")]), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        return _vm.closeConfirmDialog(false)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        return _vm.closeConfirmDialog(true)
      }
    }
  }, [_vm._v("Delete")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-419115ef!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AdminTabs/AdminDocumentations.vue
// module id = 309
// module chunks = 2